import React, { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  classifyAppBootRouteFamily,
  getCapturedAppBootProfile,
} from "../utils/adminCustomerViewBoot";

function currentLocationKey(
  pathname: string,
  search: string,
  hash: string
): string {
  return `${pathname}${search}${hash}`;
}

export default function AppBootProfileDocumentGate({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement | null {
  const location = useLocation();
  const boot = getCapturedAppBootProfile();
  const family = classifyAppBootRouteFamily(location.pathname);
  const locationKey = currentLocationKey(
    location.pathname,
    location.search,
    location.hash
  );
  const lastReloadedKeyRef = useRef<string | null>(null);

  const allowed = boot.status === "valid" && boot.profile === family;
  const shouldReload = boot.status === "valid" && boot.profile !== family;

  useLayoutEffect(() => {
    if (!shouldReload) return;
    if (lastReloadedKeyRef.current === locationKey) return;
    lastReloadedKeyRef.current = locationKey;
    window.location.reload();
  }, [shouldReload, locationKey]);

  if (!allowed) return null;
  return <>{children}</>;
}
